import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { environment } from '../../../../environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { TranslationService } from '../../../core/services/translation.service';
import { localizedURL } from '../../../core/helpers/navigation.helper';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    TranslatePipe
  ]
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();

  private destroy$ = new Subject<void>();
  private currentLang = 'en';
  public cdn = environment.cdnUrl;

  socialLinks = [
    // { icon: 'discord', url: 'https://discord.gg/xedoom', label: 'Discord' },
    // { icon: 'reddit', url: 'https://reddit.com/r/xedoom', label: 'Reddit' },
    { icon: this.cdn + '/icons/facebook_social_icon.svg', url: 'https://facebook.com/xedoom', labelKey: 'footer.social.facebook' },
    { icon: this.cdn + '/icons/instagram_social_icon.svg', url: 'https://instagram.com/xedoom', labelKey: 'footer.social.instagram' },
    { icon: this.cdn + '/icons/linkedin_logo_icon.svg', url: 'https://linkedin.com/xedoom', labelKey: 'footer.social.linkedin' },
    { icon: this.cdn + '/icons/youtube_icon.svg', url: 'https://youtube.com/xedoom', labelKey: 'footer.social.youtube' },
    { icon: this.cdn + '/icons/tweet_logo_icon.svg', url: 'https://twitter.com/xedoom', labelKey: 'footer.social.twitter' }
  ];

  companyLinks = [
    { path: '/', labelKey: 'footer.links.home' },
    { path: '/news', labelKey: 'footer.links.news' },
    { path: '/features', labelKey: 'footer.links.features' },
    { path: '/roadmap', labelKey: 'footer.links.roadmap' }
  ];

  aboutLinks = [
    { path: '/about-us', labelKey: 'footer.links.about_us' },
    { path: '/contact-us', labelKey: 'footer.links.contact_us' }
  ];

  legalLinks = [
    { path: '/terms-and-conditions', labelKey: 'footer.links.terms_of_service' },
    { path: '/privacy-policy', labelKey: 'footer.links.privacy_policy' }
  ];

  constructor(
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.translationService.getCurrentLang().pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.currentLang = lang;

      this.companyLinks = this.companyLinks.map(link => ({
        ...link,
        path: localizedURL(link.path, lang)
      }));

      this.aboutLinks = this.aboutLinks.map(link => ({
        ...link,
        path: localizedURL(link.path, lang)
      }));

      this.legalLinks = this.legalLinks.map(link => ({
        ...link,
        path: localizedURL(link.path, lang)
      }));
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
